// i18n for RE₿EL Proof™ on-chain diplomas (Base L2)
const DICT = {
  es: {
    modalTitle: "🎓 ¡Nivel completado!",
    modalSub: "Mintea tu diploma on-chain en Base L2",
    comingSoonTitle: "🎓 ¡Nivel completado!",
    comingSoonSub: "Pronto podrás reclamar este diploma como NFT on-chain en Base L2. Vuelve en cuanto activemos el minteo público.",
    comingSoonBadge: "PRÓXIMAMENTE",
    continue: "Continuar",
    walletLabel: "Tu wallet de Base:",
    walletPh: "0x... dirección de Base",
    connectWallet: "Conectar wallet",
    connecting: "Conectando…",
    walletConnected: "Wallet conectada",
    chainWrong: "Cambiando a Base…",
    btnMint: "Mintear mi diploma →",
    minting: "Registrando en blockchain…",
    waitConfirm: "Esperando confirmación on-chain…",
    okTitle: "✅ Diploma registrado en Base L2",
    okSub: "Tu diploma vivirá para siempre en la blockchain",
    skip: "Continuar sin diploma",
    basescan: "Ver en BaseScan →",
    opensea: "Ver en OpenSea →",
    verifyLink: "Compartir verificación →",
    close: "Cerrar",
    retry: "Intentar de nuevo",
    errNoWallet: "Instala MetaMask u otra wallet Web3 para mintear.",
    errReject: "Has rechazado la transacción.",
    errGas: "Fondos insuficientes para pagar el gas en Base.",
    errClaim: "El minteo on-chain falló. Verifica que el nivel esté disponible.",
    errGeneric: "Error al mintear. Inténtalo de nuevo.",
    badgePreview: "VISTA PREVIA",
    badgeMinted: "ON-CHAIN",
    walletShort: "Wallet:",
    paidGas: "Tú pagas el gas (~$0.001)",
    // VerifyPage
    verifyTitle: "RE₿EL Proof™ — Verificar Diploma",
    verifySub: "Introduce el hash de la transacción o la wallet del titular",
    verifyPh: "0x… (txHash o wallet)",
    verifyBtn: "Verificar →",
    verifyLoading: "Verificando…",
    verifyValid: "✅ DIPLOMA VÁLIDO",
    verifyInvalid: "❌ Diploma no encontrado",
    verifyTitular: "Titular",
    verifyNivel: "Nivel",
    verifyFecha: "Fecha",
    verifyWallet: "Wallet",
    verifyFooter: "RE₿EL Proof™ · Base L2 Blockchain · rebelbtc.com",
    // Profile section
    profileTitle: "RE₿EL Proof™ — Mis Diplomas On-Chain",
    profileEmpty: "Aún no has minteado ningún diploma. Completa un nivel en la Academia para desbloquearlo.",
    levelLabel: "Nivel",
    issuedOn: "Emitido",
  },
  en: {
    modalTitle: "🎓 Level completed!",
    modalSub: "Mint your on-chain diploma on Base L2",
    comingSoonTitle: "🎓 Level completed!",
    comingSoonSub: "Soon you'll be able to claim this diploma as an on-chain NFT on Base L2. Check back once public minting goes live.",
    comingSoonBadge: "COMING SOON",
    continue: "Continue",
    walletLabel: "Your Base wallet:",
    walletPh: "0x... Base address",
    connectWallet: "Connect wallet",
    connecting: "Connecting…",
    walletConnected: "Wallet connected",
    chainWrong: "Switching to Base…",
    btnMint: "Mint my diploma →",
    minting: "Recording on blockchain…",
    waitConfirm: "Waiting for on-chain confirmation…",
    okTitle: "✅ Diploma recorded on Base L2",
    okSub: "Your diploma will live forever on the blockchain",
    skip: "Continue without diploma",
    basescan: "View on BaseScan →",
    opensea: "View on OpenSea →",
    verifyLink: "Share verification →",
    close: "Close",
    retry: "Try again",
    errNoWallet: "Install MetaMask or another Web3 wallet to mint.",
    errReject: "You rejected the transaction.",
    errGas: "Insufficient funds to pay gas on Base.",
    errClaim: "On-chain mint failed. Check if the level is available.",
    errGeneric: "Mint error. Try again.",
    badgePreview: "PREVIEW",
    badgeMinted: "ON-CHAIN",
    walletShort: "Wallet:",
    paidGas: "You pay the gas (~$0.001)",
    verifyTitle: "RE₿EL Proof™ — Verify Diploma",
    verifySub: "Enter the transaction hash or holder wallet",
    verifyPh: "0x… (txHash or wallet)",
    verifyBtn: "Verify →",
    verifyLoading: "Verifying…",
    verifyValid: "✅ VALID DIPLOMA",
    verifyInvalid: "❌ Diploma not found",
    verifyTitular: "Holder",
    verifyNivel: "Level",
    verifyFecha: "Date",
    verifyWallet: "Wallet",
    verifyFooter: "RE₿EL Proof™ · Base L2 Blockchain · rebelbtc.com",
    profileTitle: "RE₿EL Proof™ — My On-Chain Diplomas",
    profileEmpty: "You haven't minted any diploma yet. Complete a level in the Academy to unlock it.",
    levelLabel: "Level",
    issuedOn: "Issued",
  },
  sk: {
    modalTitle: "🎓 Úroveň dokončená!",
    modalSub: "Mintuj svoj on-chain diplom na Base L2",
    comingSoonTitle: "🎓 Úroveň dokončená!",
    comingSoonSub: "Čoskoro si budeš môcť tento diplom nárokovať ako on-chain NFT na Base L2. Vráť sa, keď spustíme verejné mintovanie.",
    comingSoonBadge: "ČOSKORO",
    continue: "Pokračovať",
    walletLabel: "Tvoja Base peňaženka:",
    walletPh: "0x... Base adresa",
    connectWallet: "Pripojiť peňaženku",
    connecting: "Pripájam…",
    walletConnected: "Peňaženka pripojená",
    chainWrong: "Prepínam na Base…",
    btnMint: "Mintovať môj diplom →",
    minting: "Zapisujem na blockchain…",
    waitConfirm: "Čakám na on-chain potvrdenie…",
    okTitle: "✅ Diplom zaznamenaný na Base L2",
    okSub: "Tvoj diplom bude na blockchaine navždy",
    skip: "Pokračovať bez diplomu",
    basescan: "Zobraziť na BaseScan →",
    opensea: "Zobraziť na OpenSea →",
    verifyLink: "Zdieľať overenie →",
    close: "Zavrieť",
    retry: "Skús znova",
    errNoWallet: "Nainštaluj MetaMask alebo inú Web3 peňaženku.",
    errReject: "Odmietol si transakciu.",
    errGas: "Nedostatok prostriedkov na zaplatenie gasu na Base.",
    errClaim: "On-chain minting zlyhal. Skontroluj, či je úroveň dostupná.",
    errGeneric: "Chyba mintovania. Skús znova.",
    badgePreview: "NÁHĽAD",
    badgeMinted: "ON-CHAIN",
    walletShort: "Peňaženka:",
    paidGas: "Platíš gas (~$0.001)",
    verifyTitle: "RE₿EL Proof™ — Overiť Diplom",
    verifySub: "Zadaj hash transakcie alebo peňaženku držiteľa",
    verifyPh: "0x… (txHash alebo peňaženka)",
    verifyBtn: "Overiť →",
    verifyLoading: "Overujem…",
    verifyValid: "✅ PLATNÝ DIPLOM",
    verifyInvalid: "❌ Diplom nenájdený",
    verifyTitular: "Držiteľ",
    verifyNivel: "Úroveň",
    verifyFecha: "Dátum",
    verifyWallet: "Peňaženka",
    verifyFooter: "RE₿EL Proof™ · Base L2 Blockchain · rebelbtc.com",
    profileTitle: "RE₿EL Proof™ — Moje On-Chain Diplomy",
    profileEmpty: "Zatiaľ si nemintoval žiadny diplom. Dokonči úroveň v Akadémii.",
    levelLabel: "Úroveň",
    issuedOn: "Vydaný",
  },
  "zh-CN": {
    modalTitle: "🎓 关卡完成！",
    modalSub: "在 Base L2 上铸造你的链上文凭",
    comingSoonTitle: "🎓 关卡完成！",
    comingSoonSub: "很快你就可以在 Base L2 上将此文凭作为链上 NFT 领取。我们启用公开铸造后请再回来。",
    comingSoonBadge: "即将推出",
    continue: "继续",
    walletLabel: "你的 Base 钱包：",
    walletPh: "0x... Base 地址",
    connectWallet: "连接钱包",
    connecting: "连接中…",
    walletConnected: "钱包已连接",
    chainWrong: "切换至 Base…",
    btnMint: "铸造我的文凭 →",
    minting: "正在记录至区块链…",
    waitConfirm: "等待链上确认…",
    okTitle: "✅ 文凭已记录至 Base L2",
    okSub: "你的文凭将永久存在于区块链",
    skip: "跳过文凭继续",
    basescan: "在 BaseScan 查看 →",
    opensea: "在 OpenSea 查看 →",
    verifyLink: "分享验证 →",
    close: "关闭",
    retry: "重试",
    errNoWallet: "请安装 MetaMask 或其他 Web3 钱包以进行铸造。",
    errReject: "你已拒绝该交易。",
    errGas: "Base 上 gas 费用不足。",
    errClaim: "链上铸造失败。请验证该关卡是否可用。",
    errGeneric: "铸造错误。请重试。",
    badgePreview: "预览",
    badgeMinted: "ON-CHAIN",
    walletShort: "钱包：",
    paidGas: "你支付 gas 费（约 $0.001）",
    verifyTitle: "RE₿EL Proof™ — 验证文凭",
    verifySub: "输入交易哈希或持有者钱包",
    verifyPh: "0x…（交易哈希或钱包）",
    verifyBtn: "验证 →",
    verifyLoading: "验证中…",
    verifyValid: "✅ 文凭有效",
    verifyInvalid: "❌ 未找到文凭",
    verifyTitular: "持有者",
    verifyNivel: "关卡",
    verifyFecha: "日期",
    verifyWallet: "钱包",
    verifyFooter: "RE₿EL Proof™ · Base L2 Blockchain · rebelbtc.com",
    profileTitle: "RE₿EL Proof™ — 我的链上文凭",
    profileEmpty: "你尚未铸造任何文凭。在学院完成一个关卡以解锁。",
    levelLabel: "关卡",
    issuedOn: "发行日期",
  },
  de: {
    modalTitle: "🎓 Level abgeschlossen!",
    modalSub: "Präge dein Diplom on-chain auf Base L2",
    comingSoonTitle: "🎓 Level abgeschlossen!",
    comingSoonSub: "Bald kannst du dieses Diplom als NFT on-chain auf Base L2 beanspruchen. Komm zurück, sobald wir das öffentliche Minting aktivieren.",
    comingSoonBadge: "DEMNÄCHST",
    continue: "Fortfahren",
    walletLabel: "Deine Base-Wallet:",
    walletPh: "0x... Base-Adresse",
    connectWallet: "Wallet verbinden",
    connecting: "Verbinde…",
    walletConnected: "Wallet verbunden",
    chainWrong: "Wechsle zu Base…",
    btnMint: "Mein Diplom prägen →",
    minting: "Registriere auf Blockchain…",
    waitConfirm: "Warte auf On-Chain-Bestätigung…",
    okTitle: "✅ Diplom auf Base L2 registriert",
    okSub: "Dein Diplom wird für immer auf der Blockchain leben",
    skip: "Ohne Diplom fortfahren",
    basescan: "Auf BaseScan ansehen →",
    opensea: "Auf OpenSea ansehen →",
    verifyLink: "Verifizierung teilen →",
    close: "Schließen",
    retry: "Erneut versuchen",
    errNoWallet: "Installiere MetaMask oder eine andere Web3-Wallet zum Prägen.",
    errReject: "Du hast die Transaktion abgelehnt.",
    errGas: "Nicht genügend Guthaben für Gas auf Base.",
    errClaim: "On-Chain-Minting fehlgeschlagen. Überprüfe, ob das Level verfügbar ist.",
    errGeneric: "Fehler beim Prägen. Versuche es erneut.",
    badgePreview: "VORSCHAU",
    badgeMinted: "ON-CHAIN",
    walletShort: "Wallet:",
    paidGas: "Du zahlst das Gas (~$0.001)",
    verifyTitle: "RE₿EL Proof™ — Diplom verifizieren",
    verifySub: "Gib den Transaktions-Hash oder die Wallet des Inhabers ein",
    verifyPh: "0x… (txHash oder Wallet)",
    verifyBtn: "Verifizieren →",
    verifyLoading: "Verifiziere…",
    verifyValid: "✅ DIPLOM GÜLTIG",
    verifyInvalid: "❌ Diplom nicht gefunden",
    verifyTitular: "Inhaber",
    verifyNivel: "Level",
    verifyFecha: "Datum",
    verifyWallet: "Wallet",
    verifyFooter: "RE₿EL Proof™ · Base L2 Blockchain · rebelbtc.com",
    profileTitle: "RE₿EL Proof™ — Meine On-Chain-Diplome",
    profileEmpty: "Du hast noch kein Diplom geprägt. Schließe ein Level in der Akademie ab, um es freizuschalten.",
    levelLabel: "Level",
    issuedOn: "Ausgestellt",
  },
};

export const getDiplomaI18n = (lang) => DICT[lang] || DICT.es;
